var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25997",
    "data-name": "Group 25997",
    transform: "translate(-1341.5 -12098.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1614",
    "data-name": "Ellipse 1614",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1341.5 12098.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(1348.5 12072.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M341.773,33.877h.454v.454a.44.44,0,0,0,.88,0v-.454h.454a.44.44,0,0,0,0-.88h-.454v-.454a.44.44,0,0,0-.88,0V33h-.454a.44.44,0,0,0,0,.88Z",
    transform: "translate(-334.178)",
    fill: "#172b37"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Invite_head",
    "data-name": "Ellipse 1617",
    cx: 2.236,
    cy: 2.236,
    r: 2.236,
    transform: "translate(1.782 33.437)",
    fill: "#172b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M8.032,313.117a3.991,3.991,0,0,0-1.323-2.98.5.5,0,0,0-.665-.011,3.117,3.117,0,0,1-4.052,0,.5.5,0,0,0-.664.01A4.008,4.008,0,0,0,0,313.115a.442.442,0,0,0,.44.442H7.592A.44.44,0,0,0,8.032,313.117Z",
    transform: "translate(0 -272.079)",
    fill: "#172b37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.a3fb3f463d30eb3db1925636c8407c3a.svg";
export { ForwardRef as ReactComponent };